var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-structure-widget"},[_c('div',{staticClass:"project-structure-widget-body",style:(_vm.plan?'padding: 0px; overflow: hidden;':'overflow: hidden;'),attrs:{"id":"project-structure-widget-body"}},[_vm._t("body")],2),_c('div',{staticClass:"project-structure-widget-header font-weight-normal"},[_vm._t("header")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }